export default __webpack_public_path__ + "assets/d2d9cd.svg";